import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.3672 0.365918C15.8555 -0.121973 16.6445 -0.121973 17.1328 0.365918C17.6211 0.854199 17.6211 1.64561 17.1328 2.13389L10.5195 8.71475L17.1328 15.3671C17.6211 15.8554 17.6211 16.6444 17.1328 17.1327C16.6445 17.621 15.8555 17.621 15.3672 17.1327L8.71484 10.5194L2.13398 17.1327C1.6457 17.621 0.854297 17.621 0.366094 17.1327C-0.122031 16.6444 -0.122031 15.8554 0.366094 15.3671L6.98047 8.71475L0.366094 2.13389C-0.122031 1.64561 -0.122031 0.854199 0.366094 0.365918C0.854297 -0.121973 1.6457 -0.121973 2.13398 0.365918L8.71484 6.98037L15.3672 0.365918Z" })
});
export default SvgCloseIcon;
